import Utils from "@/common/utils";

// 公共配置
const common = {
  title_suffix: "江苏省高校在线开放课程中心",
  appAgreement: "1099787454317992321",
  AppPrivacyAgreement: "1056788993443423133",
};

// production
const production = {
  // baseURL: "https://higher.jiangsu.smartedu.cn/",  // 国高
  // fdsDomain: "https://higher.jiangsu.smartedu.cn/static",// 国高
  // baseURL: "http://jsmooc.net1637.com",
  // fdsDomain: "http://jsmooc.net1637.com/static",
  baseURL: "http://www.jsmooc.com.cn", // 省厅
  fdsDomain: "http://www.jsmooc.com.cn/static", // 省厅
};
// test
const test = {
  baseURL: "http://api.jiangsu.dev.net1637.com:8521",
  fdsDomain: "http://api.jiangsu.dev.net1637.com:8521/proxy",
  // appAgreement: '1099787454317992321',
};
// dev
const dev = {
  // baseURL: "http://api.jiangsu.dev.net1637.com:8521",
  // fdsDomain: "http://api.jiangsu.dev.net1637.com:8521/proxy",
  // baseURL: "http://www.jsmooc.com.cn",
  // fdsDomain: "http://www.jsmooc.com.cn/static",
  // baseURL: "http://localhost:8083",
  // fdsDomain: "http://localhost:8083/proxy",
  // appAgreement: '1099787454317992321',
  // baseURL: "http://192.168.1.128:8083",
  // fdsDomain: "http://192.168.1.128:8083/proxy",
  // baseURL: "https://higher.jiangsu.smartedu.cn/",
  // fdsDomain: "https://higher.jiangsu.smartedu.cn/static",
  baseURL: "http://www.jsmooc.com.cn",
  fdsDomain: "http://www.jsmooc.com.cn/static",
};

export const setting = Utils.Utils.extend(
  true,
  {},
  common,
  process.env.VUE_APP_MODE === "production"
    ? production
    : process.env.VUE_APP_MODE === "test"
    ? test
    : dev
);
// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: function(Vue, Option) {
    Object.defineProperty(Vue.prototype, "$setting", {
      value: setting,
    });
  },
  setting,
};
